// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './plugins/element.js'
import axios from 'axios'

Vue.config.productionTip = false

/* eslint-disable no-new */

const vue = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

const request = axios.create({
  timeout: 30000
})
// request拦截器
request.interceptors.request.use(
  config => {
    let userToken = sessionStorage.getItem('jId')
    // console.log(userToken)
    if (userToken) {
      config.headers['authorization'] = userToken // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// response拦截器
request.interceptors.response.use(
  response => {
    // console.log(response)
    return response
  },
  error => {
    // 兼容blob下载出错json提示
    console.error(error)
    if (error.response.status === 500) {
      vue.$message.error('登录失效')
      router.push('/login')
    } else if (error.response.status === 0) {
      vue.$message.error('请检查数据连接')
    } else {
      console.log(error)
      vue.$message.error('操作失败')
    }
  }
)
Vue.prototype.$http = request
Vue.prototype.apiUrl = 'http://www.healthinfochina.com:3000/api'
export default vue



// WEBPACK FOOTER //
// ./src/main.js